import { API_ROUTE_ADMIN_LOCATIONS } from '@/resources/api-routes'
import { get } from '@/util/auth'

import type { AssetLocationOriginal } from './types'

const IS_NEW_BACKEND_API = true

export async function getList() {
  return get<AssetLocationOriginal[]>(API_ROUTE_ADMIN_LOCATIONS, IS_NEW_BACKEND_API)
}
